import { styled } from '@mui/material';

export const A = styled('a')``;
export const Abbr = styled('abbr')``;
export const Address = styled('address')``;
export const Area = styled('area')``;
export const Article = styled('article')``;
export const Aside = styled('aside')``;
export const Audio = styled('audio')``;
export const B = styled('b')``;
export const Base = styled('base')``;
export const Bdi = styled('bdi')``;
export const Bdo = styled('bdo')``;
export const Big = styled('big')``;
export const Blockquote = styled('blockquote')``;
export const Body = styled('body')``;
export const Br = styled('br')``;
export const Button = styled('button')``;
export const Canvas = styled('canvas')``;
export const Caption = styled('caption')``;
export const Cite = styled('cite')``;
export const Code = styled('code')``;
export const Col = styled('col')``;
export const Colgroup = styled('colgroup')``;
export const Data = styled('data')``;
export const Datalist = styled('datalist')``;
export const Dd = styled('dd')``;
export const Del = styled('del')``;
export const Details = styled('details')``;
export const Dfn = styled('dfn')``;
export const Dialog = styled('dialog')``;
export const Div = styled('div')``;
export const Dl = styled('dl')``;
export const Dt = styled('dt')``;
export const Em = styled('em')``;
export const Embed = styled('embed')``;
export const Fieldset = styled('fieldset')``;
export const Figcaption = styled('figcaption')``;
export const Figure = styled('figure')``;
export const Footer = styled('footer')``;
export const Form = styled('form')``;
export const H1 = styled('h1')``;
export const H2 = styled('h2')``;
export const H3 = styled('h3')``;
export const H4 = styled('h4')``;
export const H5 = styled('h5')``;
export const H6 = styled('h6')``;
export const Head = styled('head')``;
export const Header = styled('header')``;
export const Hgroup = styled('hgroup')``;
export const Hr = styled('hr')``;
export const Html = styled('html')``;
export const I = styled('i')``;
export const Iframe = styled('iframe')``;
export const Img = styled('img')``;
export const Input = styled('input')``;
export const Ins = styled('ins')``;
export const Kbd = styled('kbd')``;
export const Keygen = styled('keygen')``;
export const Label = styled('label')``;
export const Legend = styled('legend')``;
export const Li = styled('li')``;
export const Link = styled('link')``;
export const Main = styled('main')``;
export const Map = styled('map')``;
export const Mark = styled('mark')``;
export const Menu = styled('menu')``;
export const Menuitem = styled('menuitem')``;
export const Meta = styled('meta')``;
export const Meter = styled('meter')``;
export const Nav = styled('nav')``;
export const Noindex = styled('noindex')``;
export const Noscript = styled('noscript')``;
export const Object = styled('object')``;
export const Ol = styled('ol')``;
export const Optgroup = styled('optgroup')``;
export const Option = styled('option')``;
export const Output = styled('output')``;
export const P = styled('p')``;
export const Param = styled('param')``;
export const Picture = styled('picture')``;
export const Pre = styled('pre')``;
export const Progress = styled('progress')``;
export const Q = styled('q')``;
export const Rp = styled('rp')``;
export const Rt = styled('rt')``;
export const Ruby = styled('ruby')``;
export const S = styled('s')``;
export const Samp = styled('samp')``;
export const Slot = styled('slot')``;
export const Script = styled('script')``;
export const Section = styled('section')``;
export const Select = styled('select')``;
export const Small = styled('small')``;
export const Source = styled('source')``;
export const Span = styled('span')``;
export const Strong = styled('strong')``;
export const Style = styled('style')``;
export const Sub = styled('sub')``;
export const Summary = styled('summary')``;
export const Sup = styled('sup')``;
export const Table = styled('table')``;
export const Template = styled('template')``;
export const Tbody = styled('tbody')``;
export const Td = styled('td')``;
export const Textarea = styled('textarea')``;
export const Tfoot = styled('tfoot')``;
export const Th = styled('th')``;
export const Thead = styled('thead')``;
export const Time = styled('time')``;
export const Title = styled('title')``;
export const Tr = styled('tr')``;
export const Track = styled('track')``;
export const U = styled('u')``;
export const Ul = styled('ul')``;
export const Var = styled('var')``;
export const Video = styled('video')``;
export const Wbr = styled('wbr')``;
export const Webview = styled('webview')``;
